import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-overlay",
    imports: [TranslateModule],
    templateUrl: "./overlay.component.html",
    styleUrl: "./overlay.component.scss"
})
export class OverlayComponent {
  @Input() text: string = "";
  @Input() textStyle: string = "";
}
